<template>
  <div class="resolve-dispute-form">
    <el-form 
      ref="resolveForm" 
      :model="form" 
      :rules="rules" 
      label-width="120px"
      class="dispute-form">
      
      <!-- 订单基本信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>订单基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="form.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="form.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家名称" prop="merchantName">
              <el-input v-model="form.merchantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="form.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="仪器信息" prop="deviceInfo">
              <el-input v-model="form.deviceInfo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 测试要求附件 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试要求附件">
              <div v-if="form.requirementFiles && form.requirementFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.requirementFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无测试要求附件"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 测试结果附件 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试结果附件">
              <div v-if="form.resultFiles && form.resultFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.resultFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无测试结果附件"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 测试说明 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="测试结果说明">
              <el-input v-model="form.testDescription" type="textarea" :rows="3" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 争议信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>争议信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="争议原因">
              <el-input 
                type="textarea" 
                v-model="form.disputeReason"
                :rows="4"
                disabled>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 争议附件列表 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="争议附件">
              <div v-if="form.disputeFiles && form.disputeFiles.length > 0" class="file-list-container">
                <el-table
                  :data="form.disputeFiles"
                  style="width: 100%"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else class="no-file">
                <el-empty description="暂无争议附件"></el-empty>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 处理结果 -->
      <el-card class="form-card">
        <div slot="header">
          <span>处理结果</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="处理方式" prop="resultType">
              <el-radio-group v-model="form.resultType" class="radio-group-left" @change="handleResultTypeChange">
                <el-radio label="PASS">解决争议
                  <input type="radio" :checked="form.resultType === 'PASS'" @change="form.resultType = 'PASS'" class="original-radio">
                </el-radio>
                <el-radio label="REJECT">驳回
                  <input type="radio" :checked="form.resultType === 'REJECT'" @change="form.resultType = 'REJECT'" class="original-radio">
                </el-radio>
                <el-radio label="FORWARD">转寄其他商家
                  <input type="radio" :checked="form.resultType === 'FORWARD'" @change="form.resultType = 'FORWARD'" class="original-radio">
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="处理说明" prop="resultRemark">
              <el-input 
                type="textarea" 
                v-model="form.resultRemark"
                :rows="4"
                placeholder="请详细说明处理结果及原因">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 文件上传区域 -->
        <el-row :gutter="20" v-if="form.resultType !== 'FORWARD'">
          <el-col :span="24">
            <el-form-item label="附件上传">
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="handleFileUpload"
                :file-list="[]"
                :on-remove="handleRemove"
                :before-upload="beforeUpload"
                drag
                multiple
                :limit="5"
                :show-file-list="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                  上传处理结果相关文件，支持PDF、Word、Excel、图片或压缩包(ZIP/RAR/7Z)等格式
                </div>
              </el-upload>
              
              <!-- 已上传文件列表 -->
              <div v-if="form.fileList && form.fileList.length > 0" class="uploaded-files">
                <h3 class="file-list-title">已上传文件</h3>
                <el-table
                  :data="form.fileList"
                  style="width: 100%; margin-top: 15px;"
                  border>
                  <el-table-column
                    prop="name"
                    label="文件名"
                    min-width="300">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="180"
                    align="center">
                    <template slot-scope="scope">
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handlePreview(scope.row)">预览</el-button>
                      <el-button 
                        type="text" 
                        size="small" 
                        @click="handleDownload(scope.row)" 
                        style="margin-left: 10px;">下载</el-button>
                      <el-button 
                        type="text" 
                        size="small"
                        style="color: #F56C6C; margin-left: 10px;"
                        @click="handleRemoveUploaded(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 操作按钮 -->
      <div class="form-actions">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交处理结果</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'ResolveDisputeForm',
  props: {
    orderId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      form: {
        projectName: '',
        orderNo: '',
        merchantName: '',
        customerName: '',
        deviceInfo: '',
        disputeReason: '',
        disputeFiles: [],
        resultType: 'PASS',
        resultRemark: '',
        fileList: [],
        // 测试相关信息
        requirementFiles: [],
        resultFiles: [],
        testDescription: ''
      },
      rules: {
        resultType: [
          { required: true, message: '请选择处理方式', trigger: 'change' }
        ],
        resultRemark: [
          { required: true, message: '请填写处理说明', trigger: 'blur' }
        ]
      },
      uploadingFiles: 0
    }
  },
  created() {
    if (this.orderId) {
      this.getOrderDetail()
    } else {
      console.error('缺少订单ID')
      this.$message.error('缺少订单ID，无法获取订单详情')
    }
  },
  methods: {
    async getOrderDetail() {
      try {
        const res = await adminApi.getOrderById(this.orderId)
        console.log('获取到的订单详情:', res)
        if (res) {
          const orderData = res
          
          // 处理测试要求附件
          const requirementFiles = Array.isArray(orderData.orderFile) 
            ? orderData.orderFile.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              })) 
            : [];
          
          // 处理测试结果附件
          const resultFiles = Array.isArray(orderData.orderResultFile) 
            ? orderData.orderResultFile.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              })) 
            : [];
          
          // 处理争议信息 - 从orderDisputeList中获取
          let disputeRemark = '';
          let disputeFiles = [];
          
          if (Array.isArray(orderData.orderDisputeList) && orderData.orderDisputeList.length > 0) {
            // 获取最新的争议记录
            const latestDispute = orderData.orderDisputeList[0];
            disputeRemark = latestDispute.disputeRemark || '';
            
            // 处理争议附件
            if (Array.isArray(latestDispute.orderDisputeFile)) {
              disputeFiles = latestDispute.orderDisputeFile.map(file => ({
                name: file.fileName || '未命名文件',
                size: file.fileSize || 0,
                url: file.fileUrl || file.url || '',
                fileId: file.fileId || file.id
              }));
            }
          }
          
          this.form = {
            ...this.form,
            projectName: orderData.projectName || '',
            orderNo: orderData.orderSn || '',
            merchantName: orderData.merchantName || '',
            customerName: orderData.customerName || '',
            deviceInfo: orderData.deviceName || '',
            disputeReason: disputeRemark,
            disputeFiles: disputeFiles,
            requirementFiles: requirementFiles,
            resultFiles: resultFiles,
            testDescription: orderData.testResultRemark || '',
            expressCompany: '',
            trackingNumber: '',
            customExpressCompany: '',
          }
        } else {
          this.$message.error('获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败: ' + (error.message || '未知错误'))
      }
    },
    // 文件上传前验证
    beforeUpload(file) {
      const isValidSize = file.size / 1024 / 1024 < 50
      if (!isValidSize) {
        this.$message.error('文件大小不能超过50MB')
        return false
      }
      
      // 检查文件类型
      const allowedTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/zip',
        'application/x-zip-compressed',
        'application/x-rar-compressed',
        'application/octet-stream',
        'application/x-7z-compressed'
      ]
      
      // 获取文件扩展名
      const fileName = file.name;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
      const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'zip', 'rar', '7z'];
      
      // 同时检查MIME类型和文件扩展名
      const isAllowedType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);
      
      if (!isAllowedType) {
        this.$message.warning('请上传PDF、Word、Excel、图片或压缩包(ZIP/RAR/7Z)格式的文件');
        console.log('文件类型不允许:', file.type, fileExtension);
        return false;
      }
      
      return true
    },
    // 处理文件上传
    handleFileUpload({ file }) {
      // 这里模拟上传，实际使用时替换为真实上传API
      this.uploadingFiles++
      
      // 在实际环境中，需要使用真实的上传API
      adminApi.uploadFile(file, '', (percent) => {
        console.log(`上传进度: ${parseInt(percent)}%`)
      }).then(res => {
        if (res) {
          const fileData = res
          const newFile = {
            name: fileData.fileId,
            size: file.size,
            uploadTime: new Date(),
            url: fileData.url || fileData.fileUrl,
            fileId: fileData.fileId || fileData.id,
            path: fileData.path || '',
            status: 'success'
          }
          
          this.form.fileList.push(newFile)
          this.$message.success(`文件 ${file.name} 上传成功`)
        } else {
          this.$message.error(`文件 ${file.name} 上传失败，请重试`)
        }
      }).catch(error => {
        console.error('文件上传失败:', error)
        this.$message.error(`文件 ${file.name} 上传失败: ${error.message || '未知错误'}`)
      }).finally(() => {
        this.uploadingFiles--
      })
    },
    // 移除已选择但未上传的文件
    handleRemove(file) {
      const index = this.form.fileList.findIndex(item => item.url === file.url)
      if (index !== -1) {
        this.form.fileList.splice(index, 1)
      }
    },
    // 移除已上传的文件
    handleRemoveUploaded(index) {
      this.form.fileList.splice(index, 1)
    },
    // 预览文件
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    // 下载文件
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    // 取消
    handleCancel() {
      this.$confirm('确定要取消当前操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push(`/admin/orders/detail/${this.orderId}`)
      }).catch(() => {})
    },
    // 提交处理结果
    handleSubmit() {
      this.$refs.resolveForm.validate(async (valid) => {
        if (valid) {
          if (this.form.resultType !== 'FORWARD' && this.uploadingFiles > 0) {
            this.$message.warning(`还有 ${this.uploadingFiles} 个文件正在上传，请等待上传完成后再提交`)
            return
          }
          
          try {
            let params = {
              disputeType: 0,
              id: this.orderId,
              orderSn: this.form.orderNo,
              orderStatus: 'DISPUTE',
              disputeResult: this.form.resultType,
              testResultRemark: this.form.resultRemark
            }
            
            // 非转寄模式时添加附件
            if (this.form.resultType !== 'FORWARD') {
              params.orderDisputeResultFileList = this.form.fileList.map(file => ({
                fileId: file.fileId,
                fileName: file.name,
                fileUrl: file.url,
                fileSize: file.size,
                filePath: file.path
              }))
            }
            
            console.log("==================")
            let res;
            
            // 根据处理方式选择不同的接口
            if (this.form.resultType === 'FORWARD') {
              // 转寄其他商家时调用 updateOrderStatus 接口
              res = await adminApi.updateOrderStatus({
                id: this.orderId,
                orderSn: this.form.orderNo,
                orderStatus: 'FORWARD',
                remarks: this.form.resultRemark
              });
            } else {
              // 其他处理方式调用 editOrder 接口
              res = await adminApi.editOrder(params);
            }
            
            if (res) {
              this.$message.success('处理结果已提交')
              
              // 根据用户角色决定跳转路径
              const userRole = localStorage.getItem('userRole')
              if (userRole === 'merchant') {
                // 商家端跳转到商家的订单页面
                this.$router.push('/merchant/orders/dispute')
              } else if (userRole === 'customer') {
                // 客户端跳转到客户的订单页面
                this.$router.push('/customer/orders/dispute')
              } else {
                // 管理员端跳转到管理员的订单页面
                this.$router.push('/admin/orders/dispute')
              }
            } else {
              this.$message.error('提交处理结果失败')
            }
          } catch (error) {
            console.error('提交处理结果失败:', error)
            this.$message.error('提交处理结果失败: ' + (error.message || '未知错误'))
          }
        } else {
          this.$message.warning('请完善表单信息')
          return false
        }
      })
    },
    // 格式化文件大小
    formatFileSize(size) {
      if (!size) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024
        index++
      }
      return size.toFixed(2) + ' ' + units[index]
    },
    // 监听处理方式变化的函数
    handleResultTypeChange() {
      // 处理方式变化时的逻辑（如果需要）
    }
  }
}
</script>

<style scoped>
.resolve-dispute-form {
  width: 100%;
}

.dispute-form {
  width: 100%;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload,
.el-textarea {
  width: 100%;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

/* 上传区域样式 */
.upload-demo {
  width: 100%;
}

.el-upload__tip {
  margin-top: 10px;
  color: #909399;
}

/* 文件列表标题 */
.file-list-title {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

.uploaded-files {
  margin-top: 20px;
}

.no-file {
  padding: 2px;
  background-color: #f9f9f9;
  border-radius: 4px;
  margin-top: 2px;
  text-align: center;
  height: auto;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-file .el-empty {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.no-file .el-empty__image {
  width: 20px;
  height: 20px;
  margin: 0;
}

.no-file .el-empty__description {
  margin-top: 1px;
  font-size: 12px;
  color: #909399;
  line-height: 1;
}

/* 预览容器 */
.preview-container {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
}

/* 删除之前的radio样式 */
.custom-radio-container {
  display: flex;
  flex-wrap: wrap;
}

.custom-radio {
  margin-right: 30px;
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;
}

::v-deep .el-radio {
  margin-right: 0;
  display: flex;
  align-items: center;
  height: auto;
}

::v-deep .el-radio__input {
  line-height: 1;
}

::v-deep .el-radio__label {
  padding-left: 5px;
  font-size: 14px;
  line-height: 1;
}

/* 确保表单项文字与值对齐 */
.el-form-item__label,
.el-form-item__content {
  display: flex;
  align-items: center;
}

/* 参考UploadTestResult.vue添加新样式 */
/* 单选框组靠左对齐 */
.radio-group-left {
  text-align: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 32px;
  line-height: 32px;
}

/* 修复单选框与标签文字对齐问题 */
.el-radio {
  margin-right: 30px;
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
}

.el-radio__input {
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  height: 14px;
  line-height: 14px;
}

.el-radio__label {
  vertical-align: middle;
  font-size: 14px;
  padding-left: 6px;
}

/* 修复处理结果标签与单选框组的对齐问题 */
.el-form-item.is-required .el-form-item__label:before {
  vertical-align: middle;
}

.el-form-item__label {
  line-height: 32px !important;
  display: flex;
  align-items: center;
  height: 32px;
}

.el-form-item__content {
  line-height: 32px !important;
  display: flex;
  align-items: center;
  min-height: 32px;
}

::v-deep .el-radio__inner {
  vertical-align: middle;
}

/* 调整Radio组件样式 */
.resolve-dispute-form .el-radio {
  margin-right: 30px;
  line-height: 32px;
  height: 32px;
}

.resolve-dispute-form .el-radio__input {
  vertical-align: middle;
}

.resolve-dispute-form .el-radio__inner {
  vertical-align: middle;
}

.resolve-dispute-form .el-radio__label {
  vertical-align: middle;
  padding-left: 6px;
}

/* 修复无障碍访问问题 */
.resolve-dispute-form .el-radio__original {
  opacity: 0;
  outline: none;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
}

/* 添加辅助屏幕阅读器类 */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* 修复Element UI无障碍问题 */
.el-radio input[type="radio"] {
  position: absolute !important;
  cursor: pointer !important;
  opacity: 0 !important;
  height: 14px !important;
  width: 14px !important;
  margin: 0 !important;
  z-index: 9 !important;
  top: 0 !important;
  left: 0 !important;
}

/* 原生radio元素样式 */
.original-radio {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  margin: 0;
}
</style>

<!-- 添加全局样式 -->
<style>
.resolve-dispute-form .el-textarea__inner {
  font-family: inherit !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #606266 !important;
}

.resolve-dispute-form .el-form-item__label,
.resolve-dispute-form .el-form-item__content {
  line-height: 32px !important;
}

/* 调整Radio组件样式 */
.resolve-dispute-form .el-radio {
  margin-right: 30px;
  line-height: 32px;
  height: 32px;
}

.resolve-dispute-form .el-radio__input {
  vertical-align: middle;
}

.resolve-dispute-form .el-radio__inner {
  vertical-align: middle;
}

.resolve-dispute-form .el-radio__label {
  vertical-align: middle;
  padding-left: 6px;
}
</style> 